export default __webpack_public_path__ + "static/media/allery-6.2b11eb36.svg";